/**
 * The persisted shape of a tender form module. This is a wire contract — it is what
 * `/api/.../TenderForms` stores and returns — so it lives here rather than in
 * forms-engine, which re-exports it for its own internal use.
 */

export interface RootStructureObject {
  _type: 'root';
  children: string[];
}

export interface SectionStructureObject {
  _type: 'section';
  children: string[];
  customization: {
    title: string;
    description: string;
    subTitle: string;
    points: number;
  };
}

export function isSectionStructureObject(
  obj: unknown,
): obj is SectionStructureObject {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    '_type' in obj &&
    obj._type === 'section'
  );
}

export interface SubSectionStructureObject {
  _type: 'subsection';
  children: string[];
  customization: {
    title: string;
    description: string;
    subTitle: string;
    showIfRule: string;
    points: number;
    concerningArea: ConcerningAreaType | null;
  };
}

export type ConcerningAreaType =
  | 'REQUALIFICATION'
  | 'ACCESSIBILITY_N_QUALITY'
  | 'SAFETY_N_LIFEGUARD'
  | 'EXPERIENCE_N_MANAGEMENT'
  | 'SUSTAINABILITY_N_ENVIRONMENT';

export function isSubSectionStructureObject(
  obj: unknown,
): obj is SubSectionStructureObject {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    '_type' in obj &&
    obj._type === 'subsection'
  );
}

export type WidgetMappedType =
  | 'TextBox'
  | 'NumericUpDown'
  | 'DatePicker'
  | 'ComboBox'
  | 'CheckBox'
  | 'RadioButton'
  | 'MultiRadioButton'
  | 'MultiplierRadioButton'
  | 'StaticText'
  | 'FileDialog';

export function isWidgetStructureObject(
  obj: unknown,
): obj is WidgetStructureObject {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    '_type' in obj &&
    obj._type === 'widget'
  );
}

export interface WidgetStructureObject<T = unknown> {
  _type: 'widget';
  _mappedType: WidgetMappedType;
  customization: T & {
    description?: string;
    showIfRule: string;
  } & (WidgetStructureObject['_mappedType'] extends 'StaticText'
      ? Record<string, never>
      : { defaultValue: unknown });
}

export type ModuleStructureObject = Record<
  string,
  | RootStructureObject
  | SectionStructureObject
  | SubSectionStructureObject
  | WidgetStructureObject
> & {
  root: RootStructureObject;
};

/***************************************
 *
 *
 *     CONDITIONING STRUCTURE FOR AUTOcompletion AND CONDITIONAL SHOW UP
 *
 *
 ****************************************/

export interface jsoneData {
  template: { $eval: string };
  context: { [key: string]: unknown };
  relatedElement: string | number;
  value: unknown;
}

export interface CombineOptionsValue {
  showIf: string[];
  completion: string[];
}

